import PropTypes from "prop-types";

interface Props {
  color: string;
  className: any;
}

export const MusicNote01 = ({
  color = "black",
  className,
}: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.875 31.2503V11.3574C15.875 10.5348 15.875 10.1235 16.0247 9.78987C16.1566 9.49581 16.369 9.24506 16.6374 9.06659C16.9418 8.86412 17.3475 8.79651 18.159 8.66127L33.1923 6.15571C34.2873 5.97321 34.8348 5.88196 35.2615 6.04045C35.6359 6.17952 35.9498 6.44541 36.1485 6.79188C36.375 7.18671 36.375 7.74176 36.375 8.85185V27.8336M15.875 31.2503C15.875 34.0807 13.5805 36.3753 10.75 36.3753C7.91954 36.3753 5.625 34.0807 5.625 31.2503C5.625 28.4198 7.91954 26.1253 10.75 26.1253C13.5805 26.1253 15.875 28.4198 15.875 31.2503ZM36.375 27.8336C36.375 30.6641 34.0805 32.9586 31.25 32.9586C28.4195 32.9586 26.125 30.6641 26.125 27.8336C26.125 25.0031 28.4195 22.7086 31.25 22.7086C34.0805 22.7086 36.375 25.0031 36.375 27.8336Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

MusicNote01.propTypes = {
  color: PropTypes.string,
}; 